<template>
  <!-- simple -->
  <div v-if="type === 'simple'">
    <div v-if="isLoading" class="spinner">
      <VProgressRing connotation="cta" :size="-4" />
    </div>
    <div v-else>
      <div class="optionsContainer">
        <p class="notification-subtitle paddingBottom ion-no-margin">Button label</p>
        <RichTextBoxV2
          id="button_label_simple"
          name="button_label"
          v-model="text"
          placeholder="Enter Text"
          :showEmoji="showEmoji"
          :showRemainingText="true"
          :maxLength="buttonTitleTextLimit"
          :disabled="action === 'COPY_CODE'"
          :showVariableInsertion="true"
          :showCustomField="true"
          :showBotVariable="true"
          :bot_id="bot_id"
        />
      </div>

      <div v-if="action === 'COPY_CODE'" class="optionsContainer">
        <p class="notification-subtitle paddingBottom ion-no-margin">Button action (Copy code)</p>
        <VTextField v-model="couponCodeText" aria-label="copy code" :maxlength="15" readonly placeholder="Enter Text" appearance="ghost" class="vivid-input"></VTextField>
      </div>

      <!-- Select Actions -->
      <div v-else>
        <div v-if="enableOptions" class="customMarginBottom">
          <p class="notification-subtitle paddingBottom ion-no-margin">Select an option</p>
          <VSelect
            v-model="action"
            aria-label="option"
            appearance="ghost"
            class="vivid-input"
            fixed-dropdown
          >
            <VOption value="website" v-if="options.openWebSite.enable" :text="options.openWebSite.text" />
            <VOption value="phone_number" v-if="options.phone_number.enable" :text="options.phone_number.text" />
          </VSelect>
        </div>
      </div>

      <!-- Simple mode action UIs -->
      <PopperActionWebsite
        v-if="action === 'website'"
        :modelValue="websitePayload"
        :showDynamicURL="showDynamicURL"
        :isBotbuilder="isBotbuilder"
        :isCarouselUrl="true"
        @update:modelValue="onWebsiteChange"
      />
      <PopperActionPhone
        v-if="action === 'phone' || action === 'phone_number'"
        :modelValue="number"
        @update:modelValue="(v) => number = v"
      />
    </div>
  </div>

  <!-- detailed -->
  <div v-if="type === 'detailed'">
    <div v-if="isLoading" class="spinner">
      <VProgressRing connotation="cta" :size="-4" />
    </div>
    <div v-else>
      <!-- Button Label -->
      <div v-if="!showSuggestionReplies" class="optionsContainer">
        <p class="notification-subtitle paddingBottom ion-no-margin">Button label</p>
          <RichTextBoxV2
          id="button_label_suggested"
          name="button_label"
          v-model="text"
          :placeholder="props.placeholderText?.title || 'Enter a title'"
          :showEmoji="showEmoji"
          :showRemainingText="true"
          :maxLength="buttonTitleTextLimit"
          :showVariableInsertion="true"
          :showCustomField="true"
          :showBotVariable="true"
          :bot_id="bot_id"
        />
      </div>

      <!-- Description -->
      <div v-if="description" class="optionsContainer">
        <p class="notification-subtitle paddingBottom ion-no-margin">Description</p>
        <RichTextBoxV2
          id="description_text"
          name="description_text"
          v-model="descriptionText"
          :placeholder="props.placeholderText?.description || 'Enter description'"
          :showRemainingText="true"
          :maxLength="descriptionLimit"
          :showVariableInsertion="true"
          :showCustomField="true"
          :showBotVariable="true"
          :bot_id="bot_id"
        />
      </div>

      <!-- Suggestion Type -->
      <div v-if="showSuggestionReplies" class="optionsContainer flex-between" style="flex-wrap: wrap;">
        <div style="min-width: 180px; flex: 1 0;" class="width100">
          <p class="notification-subtitle paddingBottom ion-no-margin">Button type</p>
          <VSelect
            v-model="suggestionButtonType"
            aria-label="buttonAction"
            appearance="ghost"
            class="vivid-input"
            fixed-dropdown
            @change="() => { payload = undefined; }"
          >
            <VOption value="suggestedReply" text="Suggested reply" />
            <VOption value="suggestedAction" text="Suggested action" />
          </VSelect>
        </div>
        <div v-if="suggestionButtonType === 'suggestedAction'" style="min-width: 250px; flex: 1 0;" class="width100">
          <p class="notification-subtitle paddingBottom ion-no-margin">Action type</p>
          <VSelect
            v-model="action"
            aria-label="buttonAction"
            appearance="ghost"
            class="vivid-input"
            fixed-dropdown
            @change="() => { payload = undefined; }"
          >
            <VOption value="phone_number" :text="options.phone_number.text" />
            <VOption value="location" :text="options.location.text" />
            <VOption value="share" :text="options.share.text" />
            <VOption value="calendar" :text="options.calendar.text" />
            <VOption value="website" :text="options.openWebSite.text" />
            <VOption value="bot_flow" :text="options.botFlow.text" />
            <VOption value="livechat" :text="options.pingLiveChat.text" />
            <VOption value="agent_or_group" :text="options.liveChat.text" />
            <VOption v-if="options.optIn.enable" value="opt_in" :disabled="!options.optIn.configured" :text="options.optIn.text + (!options.optIn.configured ? ' (Compliance Keywords not configured)' : '')" />
            <VOption v-if="options.optOut.enable" value="opt_out" :disabled="!options.optOut.configured" :text="options.optOut.text + (!options.optOut.configured ? ' (Compliance Keywords not configured)' : '')" />
          </VSelect>
        </div>
      </div>

      <!-- Select Action (non-suggestion mode) -->
      <div v-else>
        <p class="notification-subtitle paddingBottom ion-no-margin">Button Action</p>
        <VSelect
          v-model="action"
          aria-label="buttonAction"
          appearance="ghost"
          class="vivid-input"
          fixed-dropdown
          placeholder="Select an action"
          @change="() => { payload = undefined; }"
        >
          <VOption v-if="options.botFlow.enable" value="bot_flow" :text="options.botFlow.text" />
          <VOption v-if="options.pingLiveChat.enable" value="livechat" :text="options.pingLiveChat.text" />
          <VOption v-if="options.liveChat.enable" value="agent_or_group" :text="options.liveChat.text" />
          <VOption v-if="options.openWebSite.enable" value="website" :text="options.openWebSite.text" />
          <VOption v-if="options.whatsappCarouselUrl.enable" value="website" :text="options.whatsappCarouselUrl.text" />
          <VOption v-if="options.customPayload.enable" value="custom" :text="options.customPayload.text" />
          <VOption v-if="options.phone_number.enable" value="phone_number" :text="options.phone_number.text" />
          <VOption v-if="options.location.enable" value="location" :text="options.location.text" />
          <VOption v-if="options.share.enable" value="share" :text="options.share.text" />
          <VOption v-if="options.calendar.enable" value="calendar" :text="options.calendar.text" />
          <VOption v-if="options.optIn.enable" value="opt_in" :disabled="!options.optIn.configured" :text="options.optIn.text + (!options.optIn.configured ? ' (Compliance Keywords not configured)' : '')" />
          <VOption v-if="options.optOut.enable" value="opt_out" :disabled="!options.optOut.configured" :text="options.optOut.text + (!options.optOut.configured ? ' (Compliance Keywords not configured)' : '')" />
        </VSelect>
      </div>

      <!-- Suggestion reply label (shown after action selector when in suggestion mode) -->
      <div v-if="showSuggestionReplies" class="optionsContainer">
        <p class="notification-subtitle paddingBottom ion-no-margin">Button label</p>
        <RichTextBoxV2
          id="button_label_show_suggested_reply"
          name="button_label"
          v-model="text"
          :placeholder="props.placeholderText?.title || 'Enter a title'"
          :showEmoji="showEmoji"
          :showRemainingText="true"
          :maxLength="suggestionLimit"
          :showVariableInsertion="true"
          :showCustomField="true"
          :showBotVariable="true"
          :bot_id="bot_id"
        />
      </div>

      <!-- Action-specific UIs -->
      <PopperActionBotFlow
        v-if="action === 'bot_flow'"
        :modelValue="payload"
        :allBots="popperData.allBots.value"
        @update:modelValue="(v) => payload = v"
        @clear="() => { action = undefined; }"
      />

      <PopperActionAgentGroup
        v-if="action === 'agent_or_group'"
        :modelValue="payload"
        :allRoles="popperData.allRoles.value"
        :allAgents="popperData.allAgents.value"
        @update:modelValue="(v) => payload = v"
        @clear="() => { action = undefined; }"
      />

      <PopperActionLiveChat
        v-if="action === 'livechat'"
        @clear="() => { payload = undefined; action = undefined; }"
      />

      <PopperActionWebsite
        v-if="(action === 'website' || action === 'app_webview') && !options.whatsappCarouselUrl.enable"
        :modelValue="websitePayload"
        :showDynamicURL="showDynamicURL"
        :isBotbuilder="isBotbuilder"
        :isCarouselUrl="false"
        @update:modelValue="onWebsiteChange"
      />

      <!-- WhatsApp Carousel URL (simple URL input in detailed mode) -->
      <PopperActionWebsite
        v-if="action === 'website' && options.whatsappCarouselUrl.enable"
        :modelValue="websitePayload"
        :showDynamicURL="showDynamicURL"
        :isBotbuilder="isBotbuilder"
        :isCarouselUrl="true"
        @update:modelValue="onWebsiteChange"
      />

      <PopperActionCustom
        v-if="action === 'custom' || (suggestionButtonType === 'suggestedReply' && showSuggestionReplies)"
        :modelValue="payload"
        :label="(suggestionButtonType === 'suggestedReply' && showSuggestionReplies) ? (props.placeholderText?.payload || 'Enter Reply Text') : (props.placeholderText?.payload || 'Enter Custom Text')"
        :maxLength="maxlengthForSuggestedReply"
        :botId="bot_id"
        @update:modelValue="(v) => payload = v"
      />

      <PopperActionPhone
        v-if="action === 'phone_number' || action === 'phone'"
        :modelValue="number"
        @update:modelValue="(v) => number = v"
      />

      <PopperActionLocation
        v-if="action === 'location'"
        :modelValue="locationPayload"
        @update:modelValue="onLocationChange"
      />

      <PopperActionCalendar
        v-if="action === 'calendar'"
        :modelValue="calendarPayload"
        @update:modelValue="onCalendarChange"
      />
    </div>
  </div>

  <!-- Action Buttons -->
  <div class="popper-action-buttons-wrapper">
    <VButton
      v-if="!isLoading && cancelButton"
      class="vvd-btn-cancel"
      appearance="filled"
      label="Cancel"
      @click="closePopper"
      style="flex: 10 1 0%;"
    />

    <VButton
      v-if="!isLoading"
      class="vvd-btn-primary"
      connotation="cta"
      appearance="filled"
      label="Save"
      :disabled="(suggestionButtonType === 'suggestedReply' && showSuggestionReplies) ? payload === undefined : action === undefined"
      @click="submit"
      style="flex: 10 1 0%;"
    />

    <VButton
      v-if="!isLoading && deleteButton"
      class="vvd-btn-danger-outline"
      connotation="alert"
      appearance="outlined"
      icon="delete-line"
      @click="deleteBttn"
      style="flex: 0;"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, watch } from 'vue';
// @ts-ignore - .vue SFC with <script setup> lacks explicit default export declaration
import RichTextBoxV2 from '@/components/rich-text-box-v2.vue';
import { getPopperActionOptions } from '@/resources/js/suggestion-actions';
import { useUIStore } from '@/stores/ui';
import { validateUrl, validatePhoneNumber } from '@/helpers/validation.helpers';
import { decodePopperConfig, encodePopperSubmit } from '@/helpers/popper-payload.helpers';
import { usePopperData } from '@/composables/usePopperData';
import {
  PopperActionWebsite,
  PopperActionPhone,
  PopperActionBotFlow,
  PopperActionAgentGroup,
  PopperActionLiveChat,
  PopperActionLocation,
  PopperActionCalendar,
  PopperActionCustom,
} from './actions';
import type { WebsitePayload, LocationPayload, CalendarPayload } from './actions';

const props = withDefaults(defineProps<{
  type: string
  description?: boolean
  config?: {
    text?: string
    action?: string
    payload?: string
    extrainfo?: Record<string, any>
    type?: string
    url_type?: string
    description?: string
  }
  is_agent_or_group_req?: boolean
  buttonTitleTextCharLimit?: number
  descriptionLimit?: number
  removeButton?: boolean
  cancelButton?: boolean
  showDynamicURL?: boolean
  deleteButton?: boolean
  selectButtonType?: string
  enableOptions?: boolean
  showSuggestionReplies?: boolean
  showEmoji?: boolean
  channel?: 'whatsapp' | 'googlercs' | 'sms'
  isCarousel?: boolean
  carouselActionType?: 'URL' | 'QUICK_REPLY'
  isBotbuilder?: boolean
  bot_id?: string
  placeholderText?: {
    title?: string
    description?: string
    payload?: string
  }
}>(), {
  description: false,
  is_agent_or_group_req: false,
  descriptionLimit: 60,
  removeButton: false,
  cancelButton: false,
  showDynamicURL: false,
  deleteButton: false,
  enableOptions: true,
  showSuggestionReplies: false,
  showEmoji: true,
  isCarousel: false,
  isBotbuilder: false,
  bot_id: '',
});

const emit = defineEmits<{
  submit: [value: { legacy: Record<string, any>; new: Record<string, any> }]
  closePopper: []
  deleteBttn: []
}>();

// ─── State ───────────────────────────────────────────────────────────────────

const text = ref('');
const descriptionText = ref('');
const action = ref<string | undefined>(undefined);
const payload = ref<string | undefined>(undefined);
const number = ref<string | undefined>(undefined);
const website = ref('');
const urlType = ref<'static' | 'dynamic'>('static');
const openurlType = ref<'browser' | 'webview'>('browser');
const displayMode = ref('full');
const accessibilityDescription = ref('');
const locationName = ref<string | undefined>(undefined);
const locationAddress = ref<string | undefined>(undefined);
const lat = ref<string | undefined>(undefined);
const lng = ref<string | undefined>(undefined);
const eventTitle = ref('');
const eventDescription = ref('');
const calendarStart = ref<string | undefined>(undefined);
const calendarEnd = ref<string | undefined>(undefined);
const suggestionButtonType = ref('suggestedReply');
const couponCodeText = ref('<COUPON_CODE>');
const suggestionLimit = 25;

const options = ref(getPopperActionOptions()) as any;

// ─── Data Fetching ───────────────────────────────────────────────────────────

const channelRef = computed(() => props.channel);
const isAgentGroupReqRef = computed(() => props.is_agent_or_group_req);

const popperData = usePopperData({
  channel: channelRef,
  isAgentGroupReq: isAgentGroupReqRef,
});

const isLoading = popperData.isLoading;

// ─── Computed ────────────────────────────────────────────────────────────────

const popperOptions = computed(() => {
  if (props.channel?.includes('googlercs')) {
    return {
      botFlow: { enable: true },
      liveChat: { enable: true },
      phone_number: { enable: true },
      location: { enable: true },
      share: { enable: true },
      calendar: { enable: true },
      openWebSite: { enable: true },
    };
  }
  const isWhatsappCarousel = props.channel === 'whatsapp' && props.isCarousel;
  if (isWhatsappCarousel && props.carouselActionType === 'URL') {
    return {
      botFlow: { enable: false },
      liveChat: { enable: false },
      pingLiveChat: { enable: false },
      customPayload: { enable: false },
      optIn: { enable: false },
      optOut: { enable: false },
      phone_number: { enable: false },
      location: { enable: false },
      share: { enable: false },
      calendar: { enable: false },
      openWebSite: { enable: false },
      whatsappCarouselUrl: { enable: true },
    };
  }
  return {
    botFlow: { enable: true },
    liveChat: { enable: true },
    phone_number: { enable: false },
    location: { enable: false },
    share: { enable: false },
    calendar: { enable: false },
    openWebSite: { enable: false },
    whatsappCarouselUrl: { enable: isWhatsappCarousel && props.carouselActionType !== 'QUICK_REPLY' },
  };
});

const buttonTitleTextLimit = computed(() => {
  if (props.buttonTitleTextCharLimit) return props.buttonTitleTextCharLimit;
  switch (props.channel) {
    case 'whatsapp': return 20;
    case 'sms': return 25;
    case 'googlercs': return 25;
    default: return 25;
  }
});

const maxlengthForSuggestedReply = computed(() => {
  if (action.value === 'custom' && !props.showSuggestionReplies) {
    return 128;
  } else if (suggestionButtonType.value === 'suggestedReply') {
    return 25;
  }
  return 128;
});

const websitePayload = computed<WebsitePayload>(() => ({
  url: website.value,
  urlType: urlType.value,
  openurlType: openurlType.value,
  displayMode: displayMode.value,
  accessibilityDescription: accessibilityDescription.value,
}));

const locationPayload = computed<LocationPayload>(() => ({
  name: locationName.value,
  address: locationAddress.value,
  lat: lat.value,
  lng: lng.value,
}));

const calendarPayload = computed<CalendarPayload>(() => ({
  title: eventTitle.value,
  description: eventDescription.value,
  start: calendarStart.value,
  end: calendarEnd.value,
}));

// ─── Methods ─────────────────────────────────────────────────────────────────

function onWebsiteChange(val: WebsitePayload) {
  website.value = val.url;
  urlType.value = val.urlType;
  openurlType.value = val.openurlType;
  displayMode.value = val.displayMode;
  accessibilityDescription.value = val.accessibilityDescription;
}

function onLocationChange(val: LocationPayload) {
  locationName.value = val.name;
  locationAddress.value = val.address;
  lat.value = val.lat;
  lng.value = val.lng;
}

function onCalendarChange(val: CalendarPayload) {
  eventTitle.value = val.title;
  eventDescription.value = val.description;
  calendarStart.value = val.start;
  calendarEnd.value = val.end;
}

function setOptionsVisibility() {
  const popts = popperOptions.value;
  for (const confKey in popts) {
    const objConf = (popts as any)[confKey];
    if (Object.prototype.hasOwnProperty.call(options.value, confKey)) {
      if (Object.prototype.hasOwnProperty.call(objConf, 'enable')) {
        (options.value as any)[confKey].enable = objConf.enable;
      }
      if (Object.prototype.hasOwnProperty.call(objConf, 'text')) {
        (options.value as any)[confKey].text = objConf.text;
      }
    }
  }
  // Apply compliance status from fetched data
  options.value.optIn.configured = popperData.optInConfigured.value;
  options.value.optOut.configured = popperData.optOutConfigured.value;
  const isUrlOnlyCarousel = props.channel === 'whatsapp' && props.isCarousel && props.carouselActionType === 'URL';
  options.value.optIn.enable = isUrlOnlyCarousel ? false : popperData.hasOptIn.value;
  options.value.optOut.enable = isUrlOnlyCarousel ? false : popperData.hasOptOut.value;
}

function closePopper() {
  emit('closePopper');
}

function deleteBttn() {
  emit('deleteBttn');
}

function submit() {
  try {
    const result = encodePopperSubmit({
      action: action.value,
      payload: payload.value,
      text: text.value,
      website: website.value,
      number: number.value,
      openurlType: openurlType.value,
      displayMode: displayMode.value,
      accessibilityDescription: accessibilityDescription.value,
      urlType: urlType.value,
      locationName: locationName.value,
      locationAddress: locationAddress.value,
      lat: lat.value,
      lng: lng.value,
      eventTitle: eventTitle.value,
      eventDescription: eventDescription.value,
      calendarStart: calendarStart.value,
      calendarEnd: calendarEnd.value,
      descriptionText: descriptionText.value,
      description: props.description,
      showSuggestionReplies: props.showSuggestionReplies,
      suggestionButtonType: suggestionButtonType.value,
      configExtrainfo: props.config?.extrainfo,
      validateUrl,
      validatePhoneNumber,
    });

    if ('error' in result) {
      useUIStore().updateToast({ open: true, message: result.error, type: 'danger' });
      return;
    }

    emit('submit', result);
  } catch (error) {
    console.error('Exception', error);
    useUIStore().updateToast({ open: true, message: 'Something went wrong', type: 'danger' });
  }
}

// ─── Init ────────────────────────────────────────────────────────────────────

async function init() {
  try {
    await popperData.fetchAll();

    // Decode config into state
    const decoded = decodePopperConfig(props.config, popperData.allBots.value);
    text.value = decoded.text;
    descriptionText.value = decoded.descriptionText;
    action.value = decoded.action;
    payload.value = decoded.payload;
    number.value = decoded.number;
    website.value = decoded.website;
    urlType.value = decoded.urlType;
    openurlType.value = decoded.openurlType;
    displayMode.value = decoded.displayMode;
    accessibilityDescription.value = decoded.accessibilityDescription;
    locationName.value = decoded.locationName;
    locationAddress.value = decoded.locationAddress;
    lat.value = decoded.lat;
    lng.value = decoded.lng;
    eventTitle.value = decoded.eventTitle;
    eventDescription.value = decoded.eventDescription;
    calendarStart.value = decoded.calendarStart;
    calendarEnd.value = decoded.calendarEnd;
    suggestionButtonType.value = decoded.suggestionButtonType;

    if (props.showSuggestionReplies) {
      suggestionButtonType.value = 'suggestedAction';
    }

    setOptionsVisibility();
  } catch (error) {
    console.error('Exception', error);
    useUIStore().updateToast({ open: true, message: 'Something went wrong', type: 'danger' });
  }
}

// Watch for action changes to reset bot filter (behavior from original)
watch(action, (newAction, oldAction) => {
  if (oldAction === 'bot_flow' && newAction !== 'bot_flow') {
    // Bot filter is managed inside PopperActionBotFlow component
  }
});

onMounted(() => {
  init();
});
</script>

<style scoped>
.popper-action-buttons-wrapper {
  display: flex;
  gap: 20px;
  margin-top: 20px;
}
.customMarginBottom {
  margin-bottom: 20px;
}
.optionsContainer {
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.paddingBottom {
  padding-bottom: 10px;
}
.spinner {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
